
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Outlet } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Contact from './components/Contact';
import ListDashboard from './components/ListDashboard';
import QueryManager from './components/QueryManager';
import Search2 from './components/Search2';
import { API_BASE } from './config';
import './App.css';

function App() {
  const [apiStatus, setApiStatus] = useState('checking');

  useEffect(() => {
    fetch(`${API_BASE}/api/health`)
      .then(res => res.ok ? setApiStatus('online') : setApiStatus('offline'))
      .catch(() => setApiStatus('offline'));
  }, []);

  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <Link to="/" className="nav-brand">Fetcher2</Link>
                    <div className="nav-links">
            <Link to="/" className="nav-link">Dashboard</Link>
            <Link to="/lists" className="nav-link">Lists</Link>
            <Link to="/search2" className="nav-link">Search2</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
          </div>
          <div className="api-status">
            API: <span className={`status-${apiStatus}`}>{apiStatus}</span>
          </div>
        </nav>

        <main className="container">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            
            <Route path="/lists/*" element={<Outlet />}> 
              <Route index element={<ListDashboard />} />
              <Route path=":listId" element={<QueryManager />} />
            </Route>
            <Route path="/contact" element={<Contact />} />
            <Route path="/search2" element={<Search2 />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
